var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoTextLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 152,
    height: 28,
    fill: "none",
    viewBox: "0 0 152 28",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-40)",
    clipPath: "url(#clip1_3282_17850)",
    fill: "#cbe686"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m40 0.061833 4.0073-0.061833v16.056c1.0082-3.6172 5.1383-8.5844 5.1383-8.5844l6.6174-7.4096h4.9438l-9.5755 10.893 10.041 16.535h-4.7493l-8.0555-13.284c-4.0073 5.0549-4.3604 8.0744-4.3604 13.284h-4.0073z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m61.495 21.616c0-3.7615 2.7636-5.9566 6.6173-6.3482l6.8119-0.7059c-0.041-2.3909-1.7503-4.2717-4.7494-4.2717-2.7636 0-4.0891 1.7623-4.4372 3.3699l-3.4647-1.0202c0.8956-3.5296 3.7769-5.802 7.9019-5.802 5.8395 0 8.5622 3.9161 8.5622 7.9558v12.696h-3.8538v-6.1936c0 4.2716-2.7227 6.6986-6.5406 6.6986-4.0072 0-6.8528-2.6228-6.8528-6.3843zm7.6665 3.1328c4.125 0 5.7627-3.0195 5.7627-5.8793v-1.0975l-5.9572 0.6235c-2.3747 0.2731-3.5825 1.3706-3.5825 3.2153s1.6326 3.1329 3.777 3.1329z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m81.004 7.3477h3.8537v7.997c0.0768-5.1321 2.9582-8.1928 7.3186-8.1928v4.1943h-1.3256c-4.0482 0-5.9571 2.7825-5.9571 6.0338v10.11h-3.8896z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m91.834 17.303c0-6.2709 4.4372-10.465 10.118-10.465 6.075 0 9.535 4.6632 9.535 9.9912 0 0.7832-0.036 1.5303-0.118 1.9992h-15.646c0.5067 3.5245 2.9223 5.7196 6.2695 5.7196 2.492 0 4.591-1.1388 5.722-2.9783l2.881 1.8807c-1.556 2.664-4.632 4.5447-8.68 4.5447-5.9161 0-10.082-4.3489-10.082-10.697zm15.881-1.7622c-0.041-2.8598-2.452-5.2867-5.799-5.2867-3.3469 0-5.5681 2.2311-6.1515 5.2867z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m132.39 15.464h-13.158v12.032h-4.048v-27.433h4.048v11.563h13.158v-11.563h4.048v27.433h-4.048z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m138.61 17.303c0-6.2709 4.437-10.465 10.118-10.465 6.075 0 9.534 4.6632 9.534 9.9912 0 0.7832-0.035 1.5303-0.117 1.9992h-15.645c0.506 3.5245 2.917 5.7196 6.264 5.7196 2.492 0 4.59-1.1388 5.721-2.9783l2.877 1.8807c-1.556 2.664-4.632 4.5447-8.68 4.5447-5.916 0-10.082-4.3489-10.082-10.697zm15.881-1.7622c-0.041-2.8598-2.452-5.2867-5.799-5.2867s-5.568 2.2311-6.152 5.2867z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m160.09 7.3477h3.854v7.997c0.076-5.1321 2.958-8.1928 7.318-8.1928v4.1943h-1.325c-4.049 0-5.958 2.7825-5.958 6.0338v10.11h-3.889z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m170.9 17.422c0-6.1523 4.437-10.579 10.553-10.579s10.548 4.4262 10.548 10.579c0 6.1524-4.555 10.584-10.548 10.584s-10.553-4.3902-10.553-10.584zm10.548 7.0129c3.777 0 6.577-2.8185 6.577-7.0129 0-4.1943-2.8-7.0128-6.577-7.0128s-6.581 2.9782-6.581 7.0128 2.799 7.0129 6.581 7.0129z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_3282_17850"
  }, /*#__PURE__*/React.createElement("rect", {
    transform: "translate(40)",
    width: 152,
    height: 28,
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoTextLight);
export default __webpack_public_path__ + "static/media/logo-text-light.34c735aecbef64b8a987fbc7ae28b57e.svg";
export { ForwardRef as ReactComponent };